import React, { useState } from 'react';
import '../App.css';
import 'bootstrap-icons/font/bootstrap-icons.css';
import useAuth from '../hooks/useAuth';
import useAxiosPrivate from '../hooks/useAxiosPrivate';
import { validatePassword } from '../components/PasswordValidator';
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { SERVER_URL } from '../apis/Api';


export default function UserSettings() {  
    const blankAvatarDir = './img/blank-avatar.jpg';
    const { auth, setAuth } = useAuth();
    const axiosPrivate = useAxiosPrivate();

    const [email, setEmail] = React.useState('');
    const [birthday, setBirthday] = React.useState(new Date());
    const [password, setPassword] = React.useState('');
    const [passwordRepeated, setPasswordRepeated] = React.useState('');
    const [avatarSource, setAvatarSource] = useState('');
    const [avatarFileName, setAvatarFileName] = useState(blankAvatarDir);
    const [avatarFile, setAvatarFile] = useState(null);

    // set errors
    const [errors, setErrors] = useState({});

    const navigate = useNavigate();

    useEffect(() => {
        const getUserData = async () => {
            var userID;
            var birthday;
            var birthdayDate;
            var avatarSource;
            
            try {
                userID = auth.userID;  
                const res = await axiosPrivate.get('api/User/' + userID);

                birthdayDate = new Date(res.data.birthday);
                birthday = birthdayDate.toISOString().substring(0, 10);
                avatarSource = res.data.avatarSource;

                const fullAvatarUrl = avatarSource.startsWith('http')
                ? avatarSource
                : `${SERVER_URL.replace(/\/$/, '')}/${avatarSource.replace(/^\/+/, '')}`;

                // setting data
                setEmail(res.data.email);
                setBirthday(birthday);
                isImageUrl(fullAvatarUrl).then(res => {
                    res === true ? setAvatarSource(fullAvatarUrl) : setAvatarSource(blankAvatarDir);
                });
            } catch (err) {
                console.error('Error fetching user data:', err);
                
                if (err.response?.status === 401) {
                    console.log('Unauthorized - redirecting to login');
                    navigate('/login');
                } else if (err.response?.status === 403) {
                    console.log('Forbidden - insufficient permissions');
                    navigate('/unauthorized');
                } else {
                    setErrors({ server: 'Failed to load user data' });
                }
            }
        }
        
        if (auth?.userID) {
            getUserData();
        }
    }, [auth?.userID]);

    const handleChange = (e) => {
        if (e.target.files[0]) {
            var avatarFile = e.target.files[0];
            setAvatarFileName(URL.createObjectURL(avatarFile));
            setAvatarFile(avatarFile);   
        }
    }

    const handleSubmit = async (e) => {
        // prevent default behavior of the form (prevent reloading)
        e.preventDefault();

        setErrors({});

        if (!validate()) {
            return; 
        }

        const formData = new FormData();
        formData.append('id', auth.userID);
        formData.append('username', auth.username);
        formData.append('email', email);
        formData.append('password', password);
        
        const birthdayValue = (birthday instanceof Date)
            ? birthday.toISOString().substring(0, 10)
            : (typeof birthday === 'string' ? birthday : '');
        formData.append('birthday', birthdayValue);
        
        // Only append avatar file if user selected a new one
        if (avatarFile) {
            formData.append('avatarFile', avatarFile);
        }

        try {
            const res = await axiosPrivate.put(`api/User/${auth.userID}`, formData, {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            });
            console.log('User updated successfully!', res.data);
            // redirect on success
            navigate('/update-status');
        } catch (err) {
            console.error('Error updating user:', err);
            
            if (err.response?.status === 401) {
                console.log('Unauthorized - redirecting to login');
                navigate('/login');
            } else if (err.response?.status === 403) {
                console.log('Forbidden - insufficient permissions');
                navigate('/unauthorized');
            } else {
                setErrors({ server: 'Failed to update user data' });
            }
        }
    }

    const validate = () => {
        var errors = {};
        const regEx = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        const passMinLength = 8;

        // email validation
        errors.email = regEx.test(email) ? '' : 'Invalid email!';
        
        // birthday validation
        errors.birthday = birthday !== '' ? '' : 'Invalid birthday!';

        // password validation
        errors.password = (validatePassword(password, passMinLength).length === 0) ? '' : validatePassword(password, passMinLength);
        
        // password confirmed
        errors.passwordRepeated = password === passwordRepeated ? '' : 'Password have to be same!';

        setErrors(errors);

        return Object.values(errors).every(item => item === '');
    }

    function isImageUrl(url) {
        const img = new Image();
        img.src = url;

        return new Promise((resolve) => {
            img.onerror = () => resolve(false);
            img.onload = () => resolve(true);
        });
    }

    return (
        <div>
            <span>
                <label class='header h2 mt-5'>User Settings</label>
                <i class='bi bi-person-square h2 me-2'></i>
            </span>
            <div class='user-settings'>
                <form onSubmit = { handleSubmit }>
                    <div class='user-settings-form'>
                        <label class='user-settings-label'>
                            Username
                        </label>
                        <input 
                            type='text' 
                            disabled = { true } 
                            class='form-control mb-2 ms-2' 
                            placeholder={ auth.username }
                            maxLength={50}
                        />
                        <label class='user-settings-label'>
                            Email
                        </label>
                        <input 
                            type='email' 
                            class='form-control mb-2 ms-2' 
                            value={ email } 
                            onChange = { (e) => setEmail(e.target.value) } 
                            maxLength={50}
                        />
                        { errors.email && <div class='error-text'> { errors.email } </div> }
                        <label style={{ display: 'none' }} class='user-settings-label'>
                            Birthday
                        </label>
                        <input 
                            style={{ display: 'none' }} 
                            type='date' 
                            class='form-control mb-2 ms-2' 
                            value={ birthday } 
                            onChange = { (e) => setBirthday(e.target.value) }
                            maxLength={50}
                        />
                        { errors.birthday && <div class='error-text'> { errors.birthday } </div> }
                        <label class='d-none'> { /* class='user-settings-label' */ }
                            Old Password
                        </label>
                        <input 
                            class='d-none' 
                            type='password' 
                            maxLength={50}
                        /> { /* class='form-control mb-2 ms-2'/> */ }
                        <label class='register-label'>
                            New Password
                        </label>
                        <input 
                            type='password' 
                            class='form-control mb-2 ms-2' 
                            onChange = { (e) => setPassword(e.target.value) } 
                            maxLength={50}
                        />
                        {
                            errors.password &&
                            errors.password.map((error, index) => (
                                <div class='error-text' key={index}>
                                    <span>{ error }</span>
                                </div>
                            ))
                        }
                        <label class='register-label'>
                            Repeat Password
                        </label>
                        <input 
                            type='password' 
                            class='form-control mb-2 ms-2' 
                            onChange = { (e) => setPasswordRepeated(e.target.value) } 
                            maxLength={50}
                        />
                        { errors.passwordRepeated && <div class='error-text'> { errors.passwordRepeated } </div>}
                        <label class='user-settings-label'>
                            Current avatar
                        </label>
                        <img src={ avatarSource } 
                            alt='Current user avatar'
                        />
                        <br />
                        <label class='register-label'>
                            Change avatar
                        </label>
                        <label htmlFor='fileInput' class='register-label'>
                            <i class="register-add-img-icon bi bi-folder-plus h2 me-2"></i>
                        </label>
                        <input 
                            type='file' 
                            id='fileInput' 
                            style={{ display: 'none' }} 
                            onChange={ handleChange } 
                        />
                        <img src={ avatarFileName } 
                            alt='Avatar preview'
                        />
                        { errors.server && <div class='error-message'> { errors.server } </div> }
                    </div>
                    <button class='btn btn-outline-dark me-2 mt-2' type='submit'>Update</button>
                    <a href='/delete-account'>
                        <button class='btn btn-dark me-2 mt-2' type='button'>
                            <span class='button-delete-text'>
                                Delete Account
                            </span>
                            <span class='button-icon-delete'>
                                <i class='bi bi-trash-fill h5'></i>
                            </span>
                        </button>
                    </a>
                </form>
            </div>
        </div>
    );
}